import React, { useMemo } from 'react';
import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { getSystemTheme } from '../../redux/reducers/themeEditorReducer';
import { createAppTheme } from '../../styles';
import { useSyncCssVars } from '../../hooks/useSyncCssVars';

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentTheme } = useSelector((state: RootState) => state.themeEditor);

  const theme = useMemo(() => {
    const browserTheme = getSystemTheme();
    return createAppTheme(browserTheme, currentTheme?.config);
  }, [currentTheme]);

  useSyncCssVars(theme);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
